import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IPageHeaderState } from "./definitions";

const initialState: IPageHeaderState = {
    title: "",
    description: "",
};

export const pageHeaderSlice = createSlice({
    name: "pageHeader",
    initialState,
    reducers: {
        pageHeaderUpdated: (state, action: PayloadAction<IPageHeaderState>) => {
            state.title = action.payload.title;
            state.description = action.payload.description;
            state.actions = action.payload.actions;
        },
    },
});

export const { pageHeaderUpdated } = pageHeaderSlice.actions;
export const pageHeaderReducer = pageHeaderSlice.reducer;
export default pageHeaderSlice.reducer;
